// extracted by mini-css-extract-plugin
export var leftAlign = "_1y-2";
export var popper = "_1y-0";
export var subtitle = "_1y-1";